<template>
  <div class="manageCertificate">
    <div class="seach-nav">
      <el-input v-model="keyWords" size='small ' placeholder="请输入用户名"></el-input>
      <el-button type="primary" size='small ' icon="el-icon-search" @click="memberPageQuery()">搜索</el-button>
      <el-button type="primary" size='small ' icon="el-icon-zoom-in" @click="buyCertificateNumber()">添加</el-button>

    </div>
    <el-table
      :data="tableData"
      v-loading="tableLoading" element-loading-text="加载中"
      style="width: 100%">
      <el-table-column
        width="100"
        label="姓名"
        prop="userName">
      </el-table-column>
      <el-table-column
        label="性别"
        width="50"
        >
        <template slot-scope="scope">
          <span>{{scope.row.sex == 0?'女':'男'}}</span>

        </template>
      </el-table-column>
      <el-table-column
        width="120"
        label="手机号"
        prop="phoneNo">
      </el-table-column>
      <el-table-column
        label="身份证号"
        prop="idNo">
      </el-table-column>
      <el-table-column
        align="center"
        label="操作"
        width="200"
        >
        <template slot-scope="scope">
          <div style="margin-bottom:5px;">
            <el-button size="mini" type="primary" @click="showAddCertVisible(scope.$index, scope.row)">添加证书</el-button>
            <el-button size="mini" type="primary" @click="buyCertificateNumber(scope.$index, scope.row)">修改</el-button>
          </div>
          <div>
            <el-button size="mini" type="primary"  @click="printCertFun(scope.$index, scope.row)">查看证书</el-button>
            <el-button size="mini" type="danger" @click="delMemberTeamUser(scope.row)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 查询证书弹框表格 -->
    <el-drawer
      :visible.sync="showTable"
      :destroy-on-close="true"
      direction="rtl"
      size="1000px">
      <MemberCart :cartUserId='addRuleForm.cartUserId' ref="membercart"></MemberCart>
    </el-drawer>
    <!-- 添加和修改成员使用 -->
    <el-dialog :title="title" :center="true" :visible.sync="dialogFormVisible" width="30%" :destroy-on-close="true" >
      <!-- <el-divider><span>证书号50元/个</span></el-divider> -->
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" v-loading="updataLoading" element-loading-text="加载中">
        <el-form-item label="用户名称" prop="userName" :label-width="formLabelWidth">
          <el-input
            placeholder="请输入用户名称"
            v-model="ruleForm.userName"
            :disabled="false">
          </el-input>
        </el-form-item>
        <el-form-item label="名称全拼" prop="enName" :label-width="formLabelWidth">
          <el-input
            placeholder="请输入名称全拼"
            v-model="ruleForm.enName"
            :disabled="false">
          </el-input>
        </el-form-item>
        <el-form-item label="联系电话"   :label-width="formLabelWidth">
          <el-input
            placeholder="请输入联系电话"
            v-model="ruleForm.userPhone"
            :disabled="false">
          </el-input>
        </el-form-item>
        <el-form-item label="身份证号" :label-width="formLabelWidth">
          <el-input
            placeholder="请输入身份证号"
            v-model="ruleForm.IdNum"
            :disabled="false"
            autocomplete="off"
            @blur="blur"
            >
          </el-input>
        </el-form-item>
        <el-form-item label="出生日期"  :label-width="formLabelWidth" required>
         <el-col :span="11">
            <el-form-item prop="birthDay">
              <el-date-picker type="date" placeholder="选择出生日期" v-model="ruleForm.birthDay" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="性别" :label-width="formLabelWidth" prop="radio">
          <el-radio-group v-model="ruleForm.radio">
            <el-radio  label="1">男</el-radio>
            <el-radio  label="0">女</el-radio>
            <!-- <el-radio label="1" v-model="sex">男</el-radio>
            <el-radio label="0">女</el-radio> -->
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog()">取 消</el-button>
        <!-- submitForm -->
        <!-- addOrUpdataMemberTeamUser -->
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 添加证书使用 -->
    <el-dialog title="添加证书" :center="true" :visible.sync="addCertVisible" width="30%" :destroy-on-close="true">
      <!-- <el-divider><span>证书号50元/个</span></el-divider> -->
      <el-form :model="addRuleForm" :rules="addRules" ref="addRuleForm" v-loading="addRuleLoading" element-loading-text="加载中">
        <el-form-item label="用户名称" :label-width="formLabelWidth" prop="certUserName">
          <el-input
            placeholder="请输入用户名称"
            v-model="addRuleForm.certUserName"
            :disabled="true">
          </el-input>
        </el-form-item>
        <!-- <el-form-item label="联系电话" :label-width="formLabelWidth" prop="certUserPhone">
          <el-input
            placeholder="请输入联系电话"
            v-model="addRuleForm.certUserPhone"
            :disabled="true">
          </el-input>
        </el-form-item>
        <el-form-item label="身份证号" :label-width="formLabelWidth" prop="certIdNum" >
          <el-input
            placeholder="请输入身份证号"
            v-model="addRuleForm.certIdNum"
            :disabled="true">
          </el-input>
        </el-form-item> -->
        <el-form-item label="所属项目" :label-width="formLabelWidth"  prop="projectId" required>
          <el-select v-model="addRuleForm.projectId " placeholder="请选择所属项目" @change="((val)=>{selectOp(val)})">
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.projectName"
              :value="item.id"
              >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证书类别" :label-width="formLabelWidth"  prop="typeId" required>
          <el-select v-model="addRuleForm.typeId" placeholder="请选择证书类别" @change="((val)=>{selectType(val)})">
            <el-option
              v-for="item in projectIds"
              :key="item.id"
              :label="item.typeName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelAddRule('addRuleForm')">取 消</el-button>
        <el-button type="primary" @click="addRuleFormFun('addRuleForm')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="扫码支付" :center="true" :visible.sync="showPayCode" width="20%" @close="handleClose()" v-loading="loading">
      <p style="text-align:center;height:20px;margin:5px 0">
        <img src="static/images/wx_pay.png" style="width:18px; height:18px;"/>
        <span style="text-align:center;margin-left:5px;">微信扫描下方二维码，完成支付</span>
      </p >
      <div style="width:100%;height:120px;text-align:center;margin-top:20px;">
        <div id="qrcode" ref="qrCodeDiv" style="width:120px;height:120px;margin:0px auto;"></div>
      </div>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="createBuyOrderFun()">确 定</el-button>
      </div> -->
    </el-dialog>
    <div class="page-warp">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { memberPageQuery, addMemberTeamUser, updateMemberTeamUser, delMemberTeamUser, websiteAddCertUser, queryAllProject, queryCertTypeByProjectId, pageQueryMemberTeamUserCert } from '@/api/association'
import UserHeaderNav from '@/components/common/UserCenter/UserHeaderNav'
import MemberCart from '@/components/common/UserCenter/MemberCart'
import CopyRight from '@/components/common/CopyRight/CopyRight'
import {formatDate} from '@/components/common/config/formatTime.js'
// import {checkIDCard} from '@/components/common/config/checkIDCard.js'
import md5 from 'js-md5'
import QRCode from 'qrcodejs2'
export default {
  name: '',
  components: {
    UserHeaderNav,
    CopyRight,
    md5,
    QRCode,
    MemberCart
    // checkIDCard
  },
  data () {
    const idCode = (rule, value, callback) => {
      if (!value) {
        // callback(new Error('请输入身份证号'))
      } else {
        var regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/
        if (regIdCard.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的身份证号'))
        }
      }
    }
    // const addIdCode = (rule, value, callback) => {
    //   if (!value) {
    //     callback(new Error('请输入身份证号'))
    //   } else {
    //     var regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/
    //     if (regIdCard.test(value)) {
    //       callback()
    //     } else {
    //       return callback(new Error('请输入正确的身份证号'))
    //     }
    //   }
    // }
    // 设置手机号的验证规则
    // const phoneRules = (rule, value, callback) => {
    //   if (!value) {
    //     // callback(new Error('请输入联系方式'))
    //   } else {
    //     const reg = /^1[3|4|5|6|7|8][0-9]\d{8}$/
    //     if (reg.test(value)) {
    //       callback()
    //     } else {
    //       return callback(new Error('请输入正确的电话'))
    //     }
    //   }
    // }
    const checkMemberNameLetter = (rule, value, callback) => {
      var reg = /^[A-Za-z]+(\s[A-Za-z]*)*$/
      var regExp = new RegExp(reg)
      if (!regExp.test(value)) {
        callback(new Error('名称全拼应为字母'))
      } else {
        callback()
      }
    }
    // 选择项目
    const projectName = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择所属项目'))
      } else {
        callback()
      }
    }
    // 证书类型
    const typeName = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择证书类别'))
      } else {
        callback()
      }
    }

    return {
      current: null,
      loading: false,
      addRuleLoading: false,
      updataLoading: false,
      showTable: false,
      total: null,
      type: this.$route.params.type,
      currentPage: 1,
      assoUserInfo: JSON.parse(localStorage.getItem('assoUserInfo')),
      titleMsg: '个人信息',
      title: '',
      options: [],
      value: '',
      projectIds: [],
      projectIdVal: '',
      // projectId: '',
      tableData: [],
      UserCerts: [],
      certStotal: null,
      search: '',
      pageNo: 1,
      pageSize: 5,
      dialogFormVisible: false,
      addCertVisible: false,
      showPayCode: false,
      formLabelWidth: '80px',

      certId: null,
      userId: '',
      timer: null,
      keyWords: '',
      isUpdata: false,
      // 添加证书
      // typeId: '',
      memberUserId: '',
      tableLoading: false,
      addRuleForm: {
        certUserName: '',
        certUserPhone: '',
        certIdNum: '',
        cartUserId: '',
        projectId: '',
        typeId: ''
      },
      addRules: {
        certUserName: [
          { required: true, message: '请输入用户名称', trigger: 'blur' },
          { min: 2, message: '长度最少2个字符', trigger: 'blur' }
        ],
        // certUserPhone: [
        //   { required: true, validator: phoneRules, trigger: 'blur' }
        // ],
        // certIdNum: [
        //   { required: true, validator: addIdCode, trigger: 'blur' }
        // ],
        projectId: [
          { required: true, validator: projectName, trigger: 'change' }
        ],
        typeId: [
          { required: true, validator: typeName, trigger: 'change' }
        ]
      },
      ruleForm: {
        userName: '',
        enName: '',
        userPhone: '',
        IdNum: '',
        birthDay: '',
        radio: ''
      },
      rules: {
        userName: [
          { required: true, message: '请输入用户名称', trigger: 'blur' },
          { min: 2, message: '长度最少2个字符', trigger: 'blur' }
        ],
        enName: [
          { required: true, validator: checkMemberNameLetter, trigger: 'blur' }
          // { min: 3, message: '长度至少为3个字符', trigger: 'blur' }
        ],
        // userPhone: [
        //   { required: false, validator: phoneRules, trigger: 'blur' }
        // ],
        IdNum: [
          { required: false, validator: idCode, trigger: 'blur' }
        ],
        birthDay: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ],
        radio: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ]
      }

    }
  },
  methods: {
    formatDate,
    getAnalysisIdCard (card, num) {
      if (num === 1) {
      // 获取出生日期
        let birth = card.substring(6, 10) + '-' + card.substring(10, 12) + '-' + card.substring(12, 14)
        return birth
      }
      if (num === 2) {
      // 获取性别
        if (parseInt(card.substr(16, 1)) % 2 === 1) {
        // 男
          return '男'
        } else {
        // 女
          return '女'
        }
      }
      if (num === 3) {
      // 获取年龄
        var myDate = new Date()
        var month = myDate.getMonth() + 1
        var day = myDate.getDate()
        var age = myDate.getFullYear() - card.substring(6, 10) - 1
        if ((card.substring(10, 12) < month || card.substring(10, 12) === month) && card.substring(12, 14) <= day) {
          age++
        }
        return age
      }
    },
    // 查询所有成员
    memberPageQuery () {
      console.log(this.assoUserInfo.memberId)
      this.tableLoading = true
      memberPageQuery({ memberId: this.assoUserInfo.memberId, pageNo: this.pageNo, pageSize: this.pageSize }, this.keyWords).then(res => {
        this.tableLoading = false
        if (res.data.status === 0) {
          this.tableData = res.data.data.list
          this.total = res.data.data.total
          console.log(res.data)
        } else {
          this.$message.warning(res.data.msg)
        }
      }).catch(() => {
        this.tableLoading = false
        this.$message.error('网络错误')
      })
    },
    printCertFun (index, row) {
      this.showTable = true
      this.addRuleForm.cartUserId = row.id
      this.$nextTick(function () {
        this.$refs.membercart.init()
      })
    },
    // 根据id查询证书
    pageQueryMemberTeamUserCert () {
      console.log(this.assoUserInfo.memberId)
      this.tableLoading = true
      pageQueryMemberTeamUserCert({ memberId: this.assoUserInfo.memberId, pageNo: this.pageNo, pageSize: this.pageSize }, this.keyWords).then(res => {
        this.tableLoading = false
        if (res.data.status === 0) {
          this.UserCerts = res.data.data.list
          this.certStotal = res.data.data.total
          console.log(res.data)
        } else {
          this.$message.warning(res.data.msg)
        }
      }).catch(() => {
        this.tableLoading = false
        this.$message.error('网络错误')
      })
    },
    addOrUpdataMemberTeamUser () {
      this.updataLoading = true
      if (this.isUpdata) {
        updateMemberTeamUser({ id: this.userId, userName: this.ruleForm.userName, userNameLetter: this.ruleForm.enName.toUpperCase(), phoneNo: this.ruleForm.userPhone, idNo: this.ruleForm.IdNum, memberId: this.assoUserInfo.memberId, birthday: this.ruleForm.birthDay, sex: this.ruleForm.radio }).then(res => {
          this.updataLoading = false
          if (res.data.status === 0) {
            console.log(res.data.data)
            this.$message.success('修改成功')
            this.memberPageQuery()
            this.dialogFormVisible = false
          } else {
            this.$message.success(res.data.msg)
          }
        }).catch(() => {
          this.updataLoading = false
          this.$message.warning('网络错误')
        })
      } else {
        addMemberTeamUser({ userName: this.ruleForm.userName, userNameLetter: this.ruleForm.enName.toUpperCase(), phoneNo: this.ruleForm.userPhone, idNo: this.ruleForm.IdNum, memberId: this.assoUserInfo.memberId, birthday: this.ruleForm.birthDay, sex: this.ruleForm.radio }).then(res => {
          this.updataLoading = false
          if (res.data.status === 0) {
            console.log(res.data.data)
            this.$message.success('添加成员成功')
            this.memberPageQuery()
            this.dialogFormVisible = false
          } else {
            this.$message.success(res.data.msg)
          }
        }).catch(() => {
          this.updataLoading = false
          this.$message.warning('网络错误')
        })
      }
    },
    closeDialog () {
      this.dialogFormVisible = false
      this.ruleForm.birthDay = ''
      this.ruleForm.userName = ''
      this.ruleForm.userPhone = ''
      this.ruleForm.IdNum = ''
      this.ruleForm.radio = ''
      this.$refs.ruleForm.resetFields()
    },
    delMemberTeamUser (row) {
      this.$confirm('确定删除该成员信息吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delMemberTeamUser({id: row.id, memberId: this.assoUserInfo.memberId}).then(res => {
          if (res.data.status === 0) {
            console.log(res.data.data)
            this.$message.success('删除成功')
            this.memberPageQuery()
          // this.dialogFormVisible = false
          } else {
            this.$message.success(res.data.msg)
          }
        }).catch(() => {
          this.$message.warning('网络错误')
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    showAddCertVisible (index, row) {
      this.memberUserId = row.id
      this.addCertVisible = true
      this.addRuleForm.certUserName = row.userName
      this.addRuleForm.certUserPhone = row.phoneNo
      this.addRuleForm.certIdNum = row.idNo
      this.getQueryAllProject()
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!')
          // 检测身份证日期性别和选择的日期和性别是否相同
          if (this.ruleForm.IdNum !== '') {
            let birthDay = this.getAnalysisIdCard(this.ruleForm.IdNum, 1)
            let sex = ''
            if (this.getAnalysisIdCard(this.ruleForm.IdNum, 2) === '男') {
              sex = '1'
            } else if (this.getAnalysisIdCard(this.ruleForm.IdNum, 2) === '女') {
              sex = '0'
            } else {
              sex = ''
            }
            if (birthDay !== this.ruleForm.birthDay) {
              this.$message.warning('身份证出生日期与选择的出生日期不符')
              return false
            } else if (sex !== this.ruleForm.radio) {
              this.$message.warning('身份证性别与选择的性别不符')
              return false
            }
          }
          this.addOrUpdataMemberTeamUser()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    addRuleFormFun (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.websiteAddCertUser()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    cancelAddRule () {
      this.$refs.addRuleForm.resetFields()
      this.$refs.addRuleForm.clearValidate()
      this.addCertVisible = false
    },
    // 给团体会员下属成员添加证书
    websiteAddCertUser () {
      this.addRuleLoading = true
      websiteAddCertUser({ userName: this.addRuleForm.certUserName, phoneNo: this.addRuleForm.certUserPhone, idNo: this.addRuleForm.certIdNum, memberUserId: this.memberUserId, assoId: localStorage.getItem('assoId'), projectId: this.addRuleForm.projectId, typeId: this.addRuleForm.typeId, memberId: this.assoUserInfo.memberId }).then(res => {
        this.addRuleLoading = false
        if (res.data.status === 0) {
          console.log(res.data.data)
          this.$message.success('成员添加证书成功')
          this.memberPageQuery()
          this.addCertVisible = false
        } else {
          this.$message.warning(res.data.msg)
        }
      }).catch(() => {
        this.addRuleLoading = false
        this.$message.warning('网络错误')
      })
    },
    // 查询协会下所有项目
    getQueryAllProject () {
      this.options = []
      queryAllProject({ assoId: localStorage.getItem('assoId') }).then(res => {
        if (res.data.status === 0) {
          this.options = res.data.data
          console.log(res.data)
        }
      })
    },

    queryCertTypeByProjectId () {
      this.projectIds = []
      queryCertTypeByProjectId({ assoId: localStorage.getItem('assoId'), projectId: this.addRuleForm.projectId }).then(res => {
        if (res.data.status === 0) {
          this.projectIds = res.data.data
          console.log(this.projectIds, '礼包')
        }
      })
    },
    selectOp (item, event) {
      console.log(event)
      this.projectIdVal = ''
      // this.ruleForm.projectName =
      console.log(this.ruleForm.projectName)
      this.addRuleForm.projectId = item
      console.log(this.addRuleForm.projectId, 'projectId')
      this.queryCertTypeByProjectId()
    },
    selectType (item) {
      console.log(item)
      // debugger
      if (this.projectIds.length !== 0) {
        this.addRuleForm.typeId = item
        console.log(this.addRuleForm.typeId, 'typeId')
      }
    },
    handleCurrentChange: function (val) {
      this.memberPageQuery()
    },
    // 获取证书列表
    changeStatus (e) {
      // this.value = selVal
      console.log(this.value)
      this.certificatePageQuery()
    },

    // 添加或修改成员信息
    buyCertificateNumber (index, row) {
      console.log(index, row)
      this.dialogFormVisible = true
      if (row) {
        this.title = '修改成员信息'
        this.isUpdata = true
        this.ruleForm.userName = row.userName
        this.ruleForm.userPhone = row.phoneNo
        this.ruleForm.IdNum = row.idNo
        this.ruleForm.birthDay = row.birthday
        this.ruleForm.enName = row.userNameLetter
        this.ruleForm.radio = row.sex + ''
        console.log(this.ruleForm.radio, '性别')
        this.userId = row.id
      } else {
        this.title = '添加成员'
        this.ruleForm.userName = ''
        this.ruleForm.userPhone = ''
        this.ruleForm.IdNum = ''
        this.ruleForm.radio = ''
        this.ruleForm.birthDay = ''
        this.ruleForm.enName = ''
        this.isUpdata = false
      }
      // this.certPro = row.typeName
      // this.certId = row.typeId
      // this.tatolMoney = '￥' + this.certNum * 50
    },

    bindQRCode: function (str) {
      // eslint-disable-next-line no-new
      this.qrcode = new QRCode(this.$refs.qrCodeDiv, {
        text: str,
        width: 120,
        height: 120,
        colorDark: '#333333', // 二维码颜色
        colorLight: '#ffffff', // 二维码背景色
        correctLevel: QRCode.CorrectLevel.L// 容错率，L/M/H
      })
    },
    handleClose (done) {
      this.showPayCode = false
      this.dialogFormVisible = false
      clearInterval(this.timer)
    },
    closeDrawer () {
      this.$refs.membercart.handleClose()
    },
    blur () {
      if (this.ruleForm.IdNum === '') {
        return
      }
      // if(){}
      // debugger
      this.ruleForm.birthDay = this.getAnalysisIdCard(this.ruleForm.IdNum, 1)
      // this.ruleForm.radio = this.getAnalysisIdCard(this.ruleForm.IdNum, 2)
      if (this.getAnalysisIdCard(this.ruleForm.IdNum, 2) === '男') {
        this.ruleForm.radio = '1'
      } else if (this.getAnalysisIdCard(this.ruleForm.IdNum, 2) === '女') {
        this.ruleForm.radio = '0'
      } else {
        this.ruleForm.radio = ''
      }
    },
    handleDelete (index, row) {
      console.log(index, row)
    }
  },
  mounted () { // 这里必须是mouted钩子
  },
  created () {
    this.memberPageQuery()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .manageCertificate{
    width: 100%;
    padding: 20px 0px;
  }
  .page-warp{
    position: absolute;
    bottom: 10px;
  }
  .seach-nav .el-input{
    width: 200px;
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/UserCenter/manageMember.vue